export const getResponseFormData = (response, actionFormData = {}) => {
  if (Array.isArray(response)) {
    let hasFormDataResponse = false
    return response.reduce((newFormData, responseData = {}) => {
      if (responseData?.formData) {
        hasFormDataResponse = true
        return responseData?.data
          ? { ...responseData.formData, ...responseData.data }
          : responseData.formData
      }
      if (responseData?.data && !hasFormDataResponse) {
        return { ...newFormData, ...responseData.data }
      }
      return newFormData
    }, actionFormData)
  }

  if (response?.formData) {
    return response?.data
      ? { ...response.formData, ...response.data }
      : response.formData
  }
  if (response?.data) {
    return { ...actionFormData, ...response.data }
  }
  return actionFormData
}

export const getActionListFormData = (responseList = [], actionFormData = {}) =>
  getResponseFormData(responseList, actionFormData)

export const hasResponseFormData = (responseList = []) => {
  if (!Array.isArray(responseList)) {
    return Boolean(responseList?.formData || responseList?.data)
  }
  return responseList.some((response) => response?.formData || response?.data)
}
